// extracted by mini-css-extract-plugin
export default {"table":"DeliveryList_table__khOt8","tableContent":"DeliveryList_tableContent__y2cSu","extraButtons":"DeliveryList_extraButtons__AiJv1"};